import { createMuiTheme, colors } from '@material-ui/core';
import { ptBR } from '@material-ui/core/locale';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#F3F3F3',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#2C3E50'
    },
    secondary: {
      main: '#BDA260'
    },
    green: {
      main: '#51B36E'
    },
    error: {
      main: colors.red[500]
    },
    sucesso: {
      main: colors.green[500],
    },
    cinza: {
      main: 'red'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography,
  overrides: {
    // Style sheet name
    MuiTouchRipple: {
      // Name of the rule
      child: {
        // Some CSS
        backgroundColor: 'white'
      }
    }
  }
}, ptBR);

export default theme;
